import { Route } from "react-router";
import { all_routes } from "./all_routes";
import React from "react";
import { RouteLoadingFallback } from "./RouteLoadingFallback";

// Lazy load all components for code splitting
const Countries = React.lazy(() => import("../content/location/countries"));
const BlankPage = React.lazy(() => import("../pages/blankPage"));
const Calendar = React.lazy(() => import("../mainMenu/apps/calendar"));
const DataTable = React.lazy(() => import("../tables/dataTable"));
const BasicTable = React.lazy(() => import("../tables/basicTable"));
const DeleteRequest = React.lazy(() => import("../userManagement/deleteRequest"));
const Membershipplan = React.lazy(() => import("../membership/membershipplan"));
const MembershipAddon = React.lazy(() => import("../membership/membershipaddon"));
const Notes = React.lazy(() => import("../application/notes"));
const MarksForm = React.lazy(() => import("../../feature-module/academic/marks-form"));
const TeacherMarksForm = React.lazy(() => import("../../feature-module/academic/teacher-marks"));
const MarksheetViewer = React.lazy(() => import("../../feature-module/academic/marksheet-viewer"));
const MarksheetViewerix = React.lazy(() => import("../../feature-module/academic/marksheet-viewer/indexix"));
const MarksheetViewerxi = React.lazy(() => import("../../feature-module/academic/marksheet-viewer/indexxi"));
const AcademicProgress = React.lazy(() => import("../../feature-module/academic/progress"));
const AssignCard = React.lazy(() => import("../../feature-module/academic/assign-card"));
const CheckCardAssign = React.lazy(() => import("../../feature-module/academic/check-card-assign"));
const StudentAttendanceView = React.lazy(() => import("../../feature-module/academic/stuattendance"));
const Marksheeteacher = React.lazy(() => import("../../feature-module/academic/marksheet2"));
const PublishResults = React.lazy(() => import("../../feature-module/academic/publish-results"));
const OnlineExamAutoAnswer = React.lazy(() => import("../academic/examinations/exam/OnlineExamAutoAnswer"));
const OnlineExamAll = React.lazy(() => import("../academic/examinations/exam/OnlineExamAll"));
const ViewExamManual = React.lazy(() => import("../academic/examinations/exam/view-exam-manual"));
const ApiExaminationAnswerManual = React.lazy(() => import("../academic/examinations/exam/api-examination-answer-manual"));
const StudentExamManualAnswer = React.lazy(() => import("../academic/examinations/exam/student-exam-manual-answer"));
const HomeworkAnswer = React.lazy(() => import("../academic/examinations/exam/HomeworkAnswer"));
const StudentHomeworkAnswer = React.lazy(() => import("../academic/examinations/exam/student-homework-answer"));
const OfflineExam = React.lazy(() => import("../academic/examinations/exam/OfflineExam"));
const ViewHomework = React.lazy(() => import("../academic/view-homework"));
const HomeworkQuestion = React.lazy(() => import("../academic/homework-question"));
const StudentExamAutoAnswer = React.lazy(() => import("../academic/examinations/exam/StudentExamAutoAnswer"));
const PaymentSuccess = React.lazy(() => import("../../feature-module/academic/payment-success"));
const EditMarksheet = React.lazy(() => import("../../feature-module/academic/edit-marks"));
const CumulativeMarksheet = React.lazy(() => import("../../feature-module/academic/cumulative-marks"));
const EpfCalculatorPage = React.lazy(() => import("../../feature-module/academic/epf-calculator"));
const CumulativeMarksheetX = React.lazy(() => import("../../feature-module/academic/cumulative-marks-x"));
const CumulativeMarksheetXI = React.lazy(() => import("../../feature-module/academic/cumulative-marks-xi"));
const CumulativeMarksheetstu = React.lazy(() => import("../../feature-module/academic/cumulative-marksstu"));
const CumulativeMarksheetstux = React.lazy(() => import("../../feature-module/academic/cumulative-marksstux"));
const CumulativeMarksheetstuxi = React.lazy(() => import("../../feature-module/academic/cumulative-marksstuxi"));
const StudentPromotion = React.lazy(() => import("../../feature-module/academic/student-promotion"));
const StudentComponentXi = React.lazy(() => import("../../feature-module/academic/student-promotion/studentComponentXi"));
const StudentComponentXii = React.lazy(() => import("../../feature-module/academic/student-promotion/studentComponentXii"));
const StudentPromotionIX = React.lazy(() => import("../../feature-module/academic/student-promotioniX"));
const PaidFees = React.lazy(() => import("../../feature-module/academic/paid-fees"));
const DueFees = React.lazy(() => import("../../feature-module/academic/due-fees"));
const ViewMarksheet = React.lazy(() => import("../../feature-module/academic/view-marksheet"));
const Monthlydata = React.lazy(() => import("../../feature-module/academic/view-marksheet/Monthlydata"));
const ViewMarksheetX = React.lazy(() => import("../../feature-module/academic/view-marksheet-x"));
const ViewMarksheetXI = React.lazy(() => import("../../feature-module/academic/view-marksheet-xi"));
const ViewMarksheetstu = React.lazy(() => import("../../feature-module/academic/view-marksheetstu"));
const ViewMarksheetstux = React.lazy(() => import("../../feature-module/academic/view-marksheetstux"));
const ViewMarksheetstuxi = React.lazy(() => import("../../feature-module/academic/view-marksheetstuxi"));
const CompletedExam = React.lazy(() => import("../../feature-module/academic/completedexam"));
const ExamReport = React.lazy(() => import("../../feature-module/academic/exam-report"));
const UpcomingExam = React.lazy(() => import("../../feature-module/academic/upcoming-exam"));
const OnlineExamAutoTermsCondition = React.lazy(() => import("../../feature-module/academic/online-exam-auto-terms-condition"));
const OnlineExamManualTermsCondition = React.lazy(() => import("../../feature-module/academic/online-exam-manual-terms-condition"));
const StudentExamManual = React.lazy(() => import("../../feature-module/academic/student-exam-manual"));
const StudentExamAuto = React.lazy(() => import("../../feature-module/academic/student-exam-auto"));
const ViewExam = React.lazy(() => import("../../feature-module/academic/view-exam"));
const MarksheetXI_XII = React.lazy(() => import("../../feature-module/academic/marksheet-xi"));
const ViewAnswer = React.lazy(() => import("../../feature-module/academic/view-answer"));
const AttendanceAnalytics = React.lazy(() => import("../../feature-module/academic/attendance-analytics"));
const MidDayMealReview = React.lazy(() => import("../../feature-module/academic/mid-day-meal-review"));
const Feedback = React.lazy(() => import("../../feature-module/academic/feedback"));
const FeesPayment = React.lazy(() => import("../../feature-module/academic/fees-payment"));
const OfflineFeesPayment = React.lazy(() => import("../../feature-module/academic/offline-fees-payment"));
const StudentBulkUpload = React.lazy(() => import("../../feature-module/academic/student-bulk-upload"));
const TeacherBulkUpload = React.lazy(() => import("../../feature-module/academic/teacher-bulk-upload"));
const BulkMarksUpload = React.lazy(() => import("../../feature-module/academic/bulk-marks-upload"));
const BulkCumulativeDownload = React.lazy(() => import("../../feature-module/academic/bulk-cumulative-download"));
const BulkCumulativeDownloadx = React.lazy(() => import("../../feature-module/academic/bulk-cumulative-download/indexx"));
const BulkCumulativeDownloadxi = React.lazy(() => import("../academic/bulk-cumulative-download/indexxi"));
const MarksheetIX_X = React.lazy(() => import("../../feature-module/academic/marksheet-x"));
const AddFees = React.lazy(() => import("../../feature-module/academic/add-fees"));
const MarksheetV = React.lazy(() => import("../../feature-module/academic/marksheet-v"));
const PayFees = React.lazy(() => import("../../feature-module/academic/pay-fees"));
const ComingSoon = React.lazy(() => import("../pages/comingSoon"));
const Login = React.lazy(() => import("../auth/login/login"));
const Register = React.lazy(() => import("../auth/register/register"));
const TwoStepVerification = React.lazy(() => import("../auth/twoStepVerification/twoStepVerification"));
const EmailVerification = React.lazy(() => import("../auth/emailVerification/emailVerification"));
const ResetPassword = React.lazy(() => import("../auth/resetPassword/resetPassword"));
const ForgotPassword = React.lazy(() => import("../auth/forgotPassword/forgotPassword"));
const Accordion = React.lazy(() => import("../uiInterface/base-ui/accordion"));
const Avatar = React.lazy(() => import("../uiInterface/base-ui/avatar"));
const Borders = React.lazy(() => import("../uiInterface/base-ui/borders"));
const Breadcrumb = React.lazy(() => import("../uiInterface/base-ui/breadcrumb"));
const Buttons = React.lazy(() => import("../uiInterface/base-ui/buttons"));
const ButtonsGroup = React.lazy(() => import("../uiInterface/base-ui/buttonsgroup"));
const Cards = React.lazy(() => import("../uiInterface/base-ui/cards"));
const Carousel = React.lazy(() => import("../uiInterface/base-ui/carousel"));
const Colors = React.lazy(() => import("../uiInterface/base-ui/colors"));
const Dropdowns = React.lazy(() => import("../uiInterface/base-ui/dropdowns"));
const Grid = React.lazy(() => import("../uiInterface/base-ui/grid"));
const Images = React.lazy(() => import("../uiInterface/base-ui/images"));
const Lightboxes = React.lazy(() => import("../uiInterface/base-ui/lightbox"));
const Media = React.lazy(() => import("../uiInterface/base-ui/media"));
const Modals = React.lazy(() => import("../uiInterface/base-ui/modals"));
const NavTabs = React.lazy(() => import("../uiInterface/base-ui/navtabs"));
const Offcanvas = React.lazy(() => import("../uiInterface/base-ui/offcanvas"));
const Pagination = React.lazy(() => import("../uiInterface/base-ui/pagination"));
const Popovers = React.lazy(() => import("../uiInterface/base-ui/popover"));
const RangeSlides = React.lazy(() => import("../uiInterface/base-ui/rangeslider"));
const Progress = React.lazy(() => import("../uiInterface/base-ui/progress"));
const Spinner = React.lazy(() => import("../uiInterface/base-ui/spinner"));
const Toasts = React.lazy(() => import("../uiInterface/base-ui/toasts"));
const Typography = React.lazy(() => import("../uiInterface/base-ui/typography"));
const Video = React.lazy(() => import("../uiInterface/base-ui/video"));
const Error404 = React.lazy(() => import("../pages/error/error-404"));
const Error500 = React.lazy(() => import("../pages/error/error-500"));
const Preference = React.lazy(() => import("../settings/websiteSettings/preference"));
const UnderMaintenance = React.lazy(() => import("../pages/underMaintenance"));
const Todo = React.lazy(() => import("../application/todo"));
const Email = React.lazy(() => import("../application/email"));
const Chat = React.lazy(() => import("../application/chat"));
const Pages = React.lazy(() => import("../content/pages"));
const AudioCall = React.lazy(() => import("../application/call/audioCall"));
const CallHistory = React.lazy(() => import("../application/call/callHistory"));
const FileManager = React.lazy(() => import("../application/fileManager"));
const FileManager2 = React.lazy(() => import("../application/fileManager2"));
const WebpageCMS = React.lazy(() => import("../application/WebpageCMS"));
const QuestionManual = React.lazy(() => import("../academic/examinations/exam/question-manual"));
const MembershipTransaction = React.lazy(() => import("../membership/membershiptrasaction"));
const ClipBoard = React.lazy(() => import("../uiInterface/advanced-ui/clipboard"));
const Counter = React.lazy(() => import("../uiInterface/advanced-ui/counter"));
const DragAndDrop = React.lazy(() => import("../uiInterface/advanced-ui/dragdrop"));
const Rating = React.lazy(() => import("../uiInterface/advanced-ui/rating"));
const Stickynote = React.lazy(() => import("../uiInterface/advanced-ui/stickynote"));
const TextEditor = React.lazy(() => import("../uiInterface/advanced-ui/texteditor"));
const Timeline = React.lazy(() => import("../uiInterface/advanced-ui/timeline"));
const Scrollbar = React.lazy(() => import("../uiInterface/advanced-ui/uiscrollbar"));
const Apexchart = React.lazy(() => import("../uiInterface/charts/apexcharts"));
const FeatherIcons = React.lazy(() => import("../uiInterface/icons/feathericon"));
const FontawesomeIcons = React.lazy(() => import("../uiInterface/icons/fontawesome"));
const MaterialIcons = React.lazy(() => import("../uiInterface/icons/materialicon"));
const PE7Icons = React.lazy(() => import("../uiInterface/icons/pe7icons"));
const SimplelineIcons = React.lazy(() => import("../uiInterface/icons/simplelineicon"));
const ThemifyIcons = React.lazy(() => import("../uiInterface/icons/themify"));
const TypiconIcons = React.lazy(() => import("../uiInterface/icons/typicons"));
const WeatherIcons = React.lazy(() => import("../uiInterface/icons/weathericons"));
const BasicInputs = React.lazy(() => import("../uiInterface/forms/formelements/basic-inputs"));
const CheckboxRadios = React.lazy(() => import("../uiInterface/forms/formelements/checkbox-radios"));
const InputGroup = React.lazy(() => import("../uiInterface/forms/formelements/input-group"));
const GridGutters = React.lazy(() => import("../uiInterface/forms/formelements/grid-gutters"));
const FormSelect = React.lazy(() => import("../uiInterface/forms/formelements/form-select"));
const FormMask = React.lazy(() => import("../uiInterface/forms/formelements/form-mask"));
const FileUpload = React.lazy(() => import("../uiInterface/forms/formelements/fileupload"));
const FormHorizontal = React.lazy(() => import("../uiInterface/forms/formelements/layouts/form-horizontal"));
const FormVertical = React.lazy(() => import("../uiInterface/forms/formelements/layouts/form-vertical"));
const FloatingLabel = React.lazy(() => import("../uiInterface/forms/formelements/layouts/floating-label"));
const FormValidation = React.lazy(() => import("../uiInterface/forms/formelements/layouts/form-validation"));
const FormSelect2 = React.lazy(() => import("../uiInterface/forms/formelements/layouts/form-select2"));
const FormWizard = React.lazy(() => import("../uiInterface/forms/formelements/form-wizard"));
const DataTables = React.lazy(() => import("../uiInterface/table/data-tables"));
const TablesBasic = React.lazy(() => import("../uiInterface/table/tables-basic"));
const IonicIcons = React.lazy(() => import("../uiInterface/icons/ionicicons"));
const Badges = React.lazy(() => import("../uiInterface/base-ui/badges"));
const Placeholder = React.lazy(() => import("../uiInterface/base-ui/placeholder"));
const Alert = React.lazy(() => import("../uiInterface/base-ui/alert"));
const Tooltips = React.lazy(() => import("../uiInterface/base-ui/tooltips"));
const Ribbon = React.lazy(() => import("../uiInterface/advanced-ui/ribbon"));
const AdminDashboard = React.lazy(() => import("../mainMenu/adminDashboard"));
const AlertUi = React.lazy(() => import("../uiInterface/base-ui/alert-ui"));
const TeacherDashboard = React.lazy(() => import("../mainMenu/teacherDashboard"));
const StudentDasboard = React.lazy(() => import("../mainMenu/studentDashboard"));
const ParentDashboard = React.lazy(() => import("../mainMenu/parentDashboard"));
const StudentGrid = React.lazy(() => import("../peoples/students/student-grid"));
const AddStudent = React.lazy(() => import("../peoples/students/add-student"));
const StudentList = React.lazy(() => import("../peoples/students/student-list"));
const FoodMenuList = React.lazy(() => import("../peoples/students/student-list/FoodMenuList"));
const Monthlyreport = React.lazy(() => import("../peoples/students/student-list/Monthlyreport"));
const StudentLibrary = React.lazy(() => import("../peoples/students/student-details/studentLibrary"));
const StudentDetails = React.lazy(() => import("../peoples/students/student-details/studentDetails"));
const StudentFees = React.lazy(() => import("../peoples/students/student-details/studentFees"));
const StudentLeaves = React.lazy(() => import("../peoples/students/student-details/studentLeaves"));
const StudentResult = React.lazy(() => import("../peoples/students/student-details/studentResult"));
const ExaminationReport = React.lazy(() => import("../../feature-module/academic/examinations/examination-report"));
const StudentTimeTable = React.lazy(() => import("../peoples/students/student-details/studentTimeTable"));
const StudentRoutineView = React.lazy(() => import("../academic/student-routine"));
const AcademicReason = React.lazy(() => import("../academic/academic-reason"));
const ClassSyllabus = React.lazy(() => import("../academic/class-syllabus"));
const ClassSubject = React.lazy(() => import("../academic/class-subject"));
const ClassSection = React.lazy(() => import("../academic/class-section"));
const ClassRoom = React.lazy(() => import("../academic/class-room"));
const ClassRoutine = React.lazy(() => import("../academic/class-routine"));
const Routinexi = React.lazy(() => import("../academic/routinexi"));
const ScheduleClasses = React.lazy(() => import("../academic/schedule-classes"));
const Exam = React.lazy(() => import("../academic/examinations/exam"));
const ExamQuestion = React.lazy(() => import("../academic/examinations/exam-question"));
const ExamSchedule = React.lazy(() => import("../academic/examinations/exam-schedule"));
const Grade = React.lazy(() => import("../academic/examinations/grade"));
const Staff = React.lazy(() => import("../hrm/staff-list/staff"));
const Departments = React.lazy(() => import("../hrm/departments"));
const Classes = React.lazy(() => import("../academic/classes"));
const ClassHomeWork = React.lazy(() => import("../academic/class-home-work"));
const ExamAttendance = React.lazy(() => import("../academic/examinations/exam-attendance"));
const AttendanceSchool = React.lazy(() => import("../academic/attendance-school"));
const TeacherGrid = React.lazy(() => import("../peoples/teacher/teacher-grid"));
const TeacherForm = React.lazy(() => import("../peoples/teacher/teacherForm"));
const EditTeacher = React.lazy(() => import("../peoples/teacher/edit-teacher"));
const ClassTimetable = React.lazy(() => import("../academic/class-timetable"));
const Payroll = React.lazy(() => import("../hrm/payroll"));
const Designation = React.lazy(() => import("../hrm/designation"));
const ListLeaves = React.lazy(() => import("../hrm/leaves/list-leaves"));
const StaffDetails = React.lazy(() => import("../hrm/staff-list/staff-details.tsx"));
const StaffPayRoll = React.lazy(() => import("../hrm/staff-list/staff-payroll.tsx"));
const StaffLeave = React.lazy(() => import("../hrm/staff-list/staff-leave"));
const ApproveRequest = React.lazy(() => import("../hrm/leaves/approve-request"));
const TeacherList = React.lazy(() => import("../peoples/teacher/teacher-list"));
const TeacherDetails = React.lazy(() => import("../peoples/teacher/teacher-details/teacherDetails"));
const TeachersRoutine = React.lazy(() => import("../peoples/teacher/teacher-details/teachersRoutine"));
const TeacherSalary = React.lazy(() => import("../peoples/teacher/teacher-details/teacherSalary"));
const TeacherLeave = React.lazy(() => import("../peoples/teacher/teacher-details/teacherLeave"));
const TeacherLibrary = React.lazy(() => import("../peoples/teacher/teacher-details/teacherLibrary"));
const ParentGrid = React.lazy(() => import("../peoples/parent/parent-grid"));
const ParentList = React.lazy(() => import("../peoples/parent/parent-list"));
const GuardianGrid = React.lazy(() => import("../peoples/guardian/guardian-grid"));
const GuardianList = React.lazy(() => import("../peoples/guardian/guardian-list"));
const FeesGroup = React.lazy(() => import("../management/feescollection/feesGroup"));
const Login2 = React.lazy(() => import("../auth/login/login-2"));
const Login3 = React.lazy(() => import("../auth/login/login-3"));
const Login4 = React.lazy(() => import("../auth/login/login-4"));
const ResetPassword2 = React.lazy(() => import("../auth/resetPassword/resetPassword-2"));
const ResetPassword3 = React.lazy(() => import("../auth/resetPassword/resetPassword-3"));
const TwoStepVerification2 = React.lazy(() => import("../auth/twoStepVerification/twoStepVerification-2"));
const TwoStepVerification3 = React.lazy(() => import("../auth/twoStepVerification/twoStepVerification-3"));
const Register2 = React.lazy(() => import("../auth/register/register-2"));
const Register3 = React.lazy(() => import("../auth/register/register-3"));
const ForgotPassword2 = React.lazy(() => import("../auth/forgotPassword/forgotPassword-2"));
const ForgotPassword3 = React.lazy(() => import("../auth/forgotPassword/forgotPassword-3"));
const ResetPasswordSuccess = React.lazy(() => import("../auth/resetPasswordSuccess/resetPasswordSuccess"));
const ResetPasswordSuccess2 = React.lazy(() => import("../auth/resetPasswordSuccess/resetPasswordSuccess-2"));
const ResetPasswordSuccess3 = React.lazy(() => import("../auth/resetPasswordSuccess/resetPasswordSuccess-3"));
const FeesTypes = React.lazy(() => import("../management/feescollection/feesTypes"));
const FeesMaster = React.lazy(() => import("../management/feescollection/feesMaster"));
const FeesAssign = React.lazy(() => import("../management/feescollection/feesAssign"));
const CollectFees = React.lazy(() => import("../management/feescollection/collectFees"));
const StudentAttendance = React.lazy(() => import("../hrm/attendance/student-attendance"));
const TeacherAttendance = React.lazy(() => import("../hrm/attendance/teacher-attendance"));
const TeacherQrAttendanceAdmin = React.lazy(() => import("../hrm/attendance/teacher-qr-attendance/admin"));
const TeacherQrAttendanceScan = React.lazy(() => import("../hrm/attendance/teacher-qr-attendance/scan"));
const StaffAttendance = React.lazy(() => import("../hrm/attendance/staff-attendance"));
const AddStaff = React.lazy(() => import("../hrm/staff-list/add-staff"));
const EditStaff = React.lazy(() => import("../hrm/staff-list/edit-staff"));
const StaffsAttendance = React.lazy(() => import("../hrm/staff-list/staffs-attendance"));
const LibraryMember = React.lazy(() => import("../management/library/libraryMember"));
const Books = React.lazy(() => import("../management/library/books"));
const IssueBook = React.lazy(() => import("../management/library/issuesBook"));
const ReturnBook = React.lazy(() => import("../management/library/returnBook"));
const SportsList = React.lazy(() => import("../management/sports/sportsList"));
const PlayersList = React.lazy(() => import("../management/sports/playersList"));
const HostelRooms = React.lazy(() => import("../management/hostel/hostelRooms"));
const HostelList = React.lazy(() => import("../management/hostel/hostelList"));
const Monthwise = React.lazy(() => import("../management/hostel/monthwise"));
const StudyMaterial = React.lazy(() => import("../management/study-material/studyMaterial"));
const HostelType = React.lazy(() => import("../management/hostel/hostelType"));
const TransportRoutes = React.lazy(() => import("../management/transport/transportRoutes"));
const LiveClass = React.lazy(() => import("../management/transport/liveclass"));
const TransportPickupPoints = React.lazy(() => import("../management/transport/transportPickupPoints"));
const TransportVehicleDrivers = React.lazy(() => import("../management/transport/transportVehicleDrivers"));
const TransportVehicle = React.lazy(() => import("../management/transport/transportVehicle"));
const TransportAssignVehicle = React.lazy(() => import("../management/transport/transportAssignVehicle"));
const RolesPermissions = React.lazy(() => import("../userManagement/rolesPermissions"));
const Permission = React.lazy(() => import("../userManagement/permission"));
const Manageusers = React.lazy(() => import("../userManagement/manageusers"));
const Profilesettings = React.lazy(() => import("../settings/generalSettings/profile"));
const Securitysettings = React.lazy(() => import("../settings/generalSettings/security"));
const Notificationssettings = React.lazy(() => import("../settings/generalSettings/notifications"));
const ConnectedApps = React.lazy(() => import("../settings/generalSettings/connectedApps"));
const CompanySettings = React.lazy(() => import("../settings/websiteSettings/companySettings"));
const Localization = React.lazy(() => import("../settings/websiteSettings/localization"));
const Prefixes = React.lazy(() => import("../settings/websiteSettings/prefixes"));
const Socialauthentication = React.lazy(() => import("../settings/websiteSettings/socialAuthentication"));
const Languagesettings = React.lazy(() => import("../settings/websiteSettings/language"));
const InvoiceSettings = React.lazy(() => import("../settings/appSettings/invoiceSettings"));
const CustomFields = React.lazy(() => import("../settings/appSettings/customFields"));
const EmailSettings = React.lazy(() => import("../settings/systemSettings/emailSettings"));
const Emailtemplates = React.lazy(() => import("../settings/systemSettings/email-templates"));
const SmsSettings = React.lazy(() => import("../settings/systemSettings/smsSettings"));
const OtpSettings = React.lazy(() => import("../settings/systemSettings/otp-settings"));
const GdprCookies = React.lazy(() => import("../settings/systemSettings/gdprCookies"));
const PaymentGateways = React.lazy(() => import("../settings/financialSettings/paymentGateways"));
const TaxRates = React.lazy(() => import("../settings/financialSettings/taxRates"));
const SchoolSettings = React.lazy(() => import("../settings/academicSettings/schoolSettings"));
const Religion = React.lazy(() => import("../settings/academicSettings/religion"));
const Storage = React.lazy(() => import("../settings/otherSettings/storage"));
const BanIpAddress = React.lazy(() => import("../settings/otherSettings/banIpaddress"));
const AllBlogs = React.lazy(() => import("../content/blog/allBlogs"));
const BlogCategories = React.lazy(() => import("../content/blog/blogCategories"));
const BlogComments = React.lazy(() => import("../content/blog/blogComments"));
const BlogTags = React.lazy(() => import("../content/blog/blogTags"));
const Faq = React.lazy(() => import("../content/faq"));
const Cities = React.lazy(() => import("../content/location/cities"));
const States = React.lazy(() => import("../content/location/states"));
const Testimonials = React.lazy(() => import("../content/testimonials"));
const AccountsIncome = React.lazy(() => import("../accounts/accounts-income"));
const AccountsInvoices = React.lazy(() => import("../accounts/accounts-invoices"));
const AccountsTransactions = React.lazy(() => import("../accounts/accounts-transactions"));
const AddInvoice = React.lazy(() => import("../accounts/add-invoice"));
const EditInvoice = React.lazy(() => import("../accounts/edit-invoice"));
const Expense = React.lazy(() => import("../accounts/expense"));
const FinancialReview = React.lazy(() => import("../accounts/financial-review"));
const ExpensesCategory = React.lazy(() => import("../accounts/expenses-category"));
const IncomeCategory = React.lazy(() => import("../accounts/income-category"));
const Invoice = React.lazy(() => import("../accounts/invoice"));
const NoticeBoard = React.lazy(() => import("../announcements/notice-board"));
const Tickets = React.lazy(() => import("../support/tickets"));
const TicketGrid = React.lazy(() => import("../support/ticket-grid"));
const TicketDetails = React.lazy(() => import("../support/ticket-details"));
const SupportChat = React.lazy(() => import("../support/support-chat"));
const FeesReport = React.lazy(() => import("../report/fees-report/feesReport"));
const LeaveReport = React.lazy(() => import("../report/leave-report/leaveReport"));
const GradeReport = React.lazy(() => import("../report/grade-report/gradeReport"));
const StudentReport = React.lazy(() => import("../report/student-report/studentReport"));
const ClassReport = React.lazy(() => import("../report/class-report/classReport"));
const AttendanceReport = React.lazy(() => import("../report/attendance-report/attendanceReport"));
const ContactMessages = React.lazy(() => import("../support/contactMessages"));
const Events = React.lazy(() => import("../announcements/events"));
const Profile = React.lazy(() => import("../pages/profile"));
const StudentAttendanceType = React.lazy(() => import("../report/attendance-report/studentAttendanceType"));
const StaffReport = React.lazy(() => import("../report/attendance-report/staffReport"));
const TeacherReport = React.lazy(() => import("../report/attendance-report/teacherReport"));
const StaffDayWise = React.lazy(() => import("../report/attendance-report/staffDayWise"));
const TeacherDayWise = React.lazy(() => import("../report/attendance-report/teacherDayWise"));
const StudentDayWise = React.lazy(() => import("../report/attendance-report/studentDayWise"));
const DailyAttendance = React.lazy(() => import("../report/attendance-report/dailyAttendance"));
const LockScreen = React.lazy(() => import("../auth/lockScreen"));
const EmailVerification2 = React.lazy(() => import("../auth/emailVerification/emailVerification-2"));
const EmailVerification3 = React.lazy(() => import("../auth/emailVerification/emailVerification-3"));
const NotificationActivities = React.lazy(() => import("../pages/profile/activities"));
const Videocall = React.lazy(() => import("../application/call/videoCall"));
const ClassTimetableView = React.lazy(() => import("../academic/class-routineview"));
const ClassTimetableViewTeacher = React.lazy(() => import("../academic/class-routineview/indexTeacher"));
const ProvisionalTimetable = React.lazy(() => import("../academic/provisional-timetable"));
const Study = React.lazy(() => import("../announcements/study"));
const SendSms = React.lazy(() => import("../sendSms/SendSms"));
const StudyMaterialView = React.lazy(() => import("../management/study-material/studyMaterialView"));
const StudyMaterialFeedbacks = React.lazy(() => import("../management/study-material/studyMaterialFeedbacks"));
const Addmissionapp = React.lazy(() => import("../management/study-material/addmissionapp"));
const ApplicationReceived = React.lazy(() => import("../management/study-material/application-received"));

const routes = all_routes;

// Wrapper component for lazy-loaded routes
const LazyRoute = ({ children }: { children: React.ReactNode }) => (
  <React.Suspense fallback={<RouteLoadingFallback />}>
    {children}
  </React.Suspense>
);

export const publicRoutes = [
  {
    path: routes.adminDashboard,
    element: <LazyRoute><AdminDashboard /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.teacherDashboard,
    element: <LazyRoute><TeacherDashboard /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.studentDashboard,
    element: <LazyRoute><StudentDasboard /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.parentDashboard,
    element: <LazyRoute><ParentDashboard /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.audioCall,
    element: <LazyRoute><AudioCall /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.provisionalTimetable,
    element: <LazyRoute><ProvisionalTimetable /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.callHistory,
    element: <LazyRoute><CallHistory /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.connectedApps,
    element: <LazyRoute><ConnectedApps /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.countries,
    element: <LazyRoute><Countries /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.blankPage,
    element: <LazyRoute><BlankPage /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.calendar,
    element: <LazyRoute><Calendar /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.membershipplan,
    element: <LazyRoute><Membershipplan /></LazyRoute>,
  },
  {
    path: routes.membershipAddon,
    element: <LazyRoute><MembershipAddon /></LazyRoute>,
  },
  {
    path: routes.membershipTransaction,
    element: <LazyRoute><MembershipTransaction /></LazyRoute>,
  },
  {
    path: routes.notes,
    element: <LazyRoute><Notes /></LazyRoute>,
  },
  {
    path: routes.customFields,
    element: <LazyRoute><CustomFields /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.dataTables,
    element: <LazyRoute><DataTable /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.OnlineExamAutoAnswer,
    element: <LazyRoute><OnlineExamAutoAnswer /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.ApiExaminationAnswerManual,
    element: <LazyRoute><ApiExaminationAnswerManual /></LazyRoute>,
    route: Route,
  },
  {
    path: `${routes.StudentExamManualAnswer}/:exam_hash/:student_id`,
    element: <LazyRoute><StudentExamManualAnswer /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.OnlineExamAll,
    element: <LazyRoute><OnlineExamAll /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.viewExamManual,
    element: <LazyRoute><ViewExamManual /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.HomeworkAnswer,
    element: <LazyRoute><HomeworkAnswer /></LazyRoute>,
    route: Route,
  },
  {
    path: `${routes.StudentHomeworkAnswer}/:homeworkHash/:studentId`,
    element: <LazyRoute><StudentHomeworkAnswer /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.OfflineExam,
    element: <LazyRoute><OfflineExam /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.viewHomework,
    element: <LazyRoute><ViewHomework /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.homeworkQuestion,
    element: <LazyRoute><HomeworkQuestion /></LazyRoute>,
    route: Route,
  },
  {
    path: `${routes.StudentExamAutoAnswer}/:exam_hash/:student_id`,
    element: <LazyRoute><StudentExamAutoAnswer /></LazyRoute>,
    route: Route,
  },
  {
    path: `${routes.ViewAnswer}/:examHash`,
    element: <LazyRoute><ViewAnswer /></LazyRoute>,
    route: Route,
  },

  {
    path: routes.ViewAnswer,
    element: <LazyRoute><ViewAnswer /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.Feedback,
    element: <LazyRoute><Feedback /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.tablesBasic,
    element: <LazyRoute><BasicTable /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.deleteRequest,
    element: <LazyRoute><DeleteRequest /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.cities,
    element: <LazyRoute><Cities /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.accordion,
    element: <LazyRoute><Accordion /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.avatar,
    element: <LazyRoute><Avatar /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.badges,
    element: <LazyRoute><Badges /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.border,
    element: <LazyRoute><Borders /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.breadcrums,
    element: <LazyRoute><Breadcrumb /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.button,
    element: <LazyRoute><Buttons /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.buttonGroup,
    element: <LazyRoute><ButtonsGroup /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.cards,
    element: <LazyRoute><Cards /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.carousel,
    element: <LazyRoute><Carousel /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.colors,
    element: <LazyRoute><Colors /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.dropdowns,
    element: <LazyRoute><Dropdowns /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.grid,
    element: <LazyRoute><Grid /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.images,
    element: <LazyRoute><Images /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.lightbox,
    element: <LazyRoute><Lightboxes /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.media,
    element: <LazyRoute><Media /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.modals,
    element: <LazyRoute><Modals /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.QuestionManual,
    element: <LazyRoute><QuestionManual /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.navTabs,
    element: <LazyRoute><NavTabs /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.offcanvas,
    element: <LazyRoute><Offcanvas /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.pagination,
    element: <LazyRoute><Pagination /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.popover,
    element: <LazyRoute><Popovers /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.rangeSlider,
    element: <LazyRoute><RangeSlides /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.progress,
    element: <LazyRoute><Progress /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.spinner,
    element: <LazyRoute><Spinner /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.typography,
    element: <LazyRoute><Typography /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.video,
    element: <LazyRoute><Video /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.toasts,
    element: <LazyRoute><Toasts /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.ExaminationReport,
    element: <LazyRoute><ExaminationReport /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.banIpAddress,
    element: <LazyRoute><BanIpAddress /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.preference,
    element: <LazyRoute><Preference /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.todo,
    element: <LazyRoute><Todo /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.email,
    element: <LazyRoute><Email /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.videoCall,
    element: <LazyRoute><Videocall /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.chat,
    element: <LazyRoute><Chat /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.pages,
    element: <LazyRoute><Pages /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.fileManager,
    element: <LazyRoute><FileManager /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.fileManager2,
    element: <LazyRoute><FileManager2 /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.WebpageCMS,
    element: <LazyRoute><WebpageCMS /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.faq,
    element: <LazyRoute><Faq /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.states,
    element: <LazyRoute><States /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.testimonials,
    element: <LazyRoute><Testimonials /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.clipboard,
    element: <LazyRoute><ClipBoard /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.counter,
    element: <LazyRoute><Counter /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.dragandDrop,
    element: <LazyRoute><DragAndDrop /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.rating,
    element: <LazyRoute><Rating /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.stickyNotes,
    element: <LazyRoute><Stickynote /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.textEditor,
    element: <LazyRoute><TextEditor /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.timeLine,
    element: <LazyRoute><Timeline /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.scrollBar,
    element: <LazyRoute><Scrollbar /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.apexChat,
    element: <LazyRoute><Apexchart /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.featherIcons,
    element: <LazyRoute><FeatherIcons /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.falgIcons,
    element: <LazyRoute><FeatherIcons /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.fantawesome,
    element: <LazyRoute><FontawesomeIcons /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.materialIcon,
    element: <LazyRoute><MaterialIcons /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.pe7icon,
    element: <LazyRoute><PE7Icons /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.simpleLineIcon,
    element: <LazyRoute><SimplelineIcons /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.themifyIcon,
    element: <LazyRoute><ThemifyIcons /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.typicon,
    element: <LazyRoute><TypiconIcons /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.basicInput,
    element: <LazyRoute><BasicInputs /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.weatherIcon,
    element: <LazyRoute><WeatherIcons /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.checkboxandRadion,
    element: <LazyRoute><CheckboxRadios /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.inputGroup,
    element: <LazyRoute><InputGroup /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.gridandGutters,
    element: <LazyRoute><GridGutters /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.formSelect,
    element: <LazyRoute><FormSelect /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.formMask,
    element: <LazyRoute><FormMask /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.fileUpload,
    element: <LazyRoute><FileUpload /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.horizontalForm,
    element: <LazyRoute><FormHorizontal /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.verticalForm,
    element: <LazyRoute><FormVertical /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.floatingLable,
    element: <LazyRoute><FloatingLabel /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.formValidation,
    element: <LazyRoute><FormValidation /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.reactSelect,
    element: <LazyRoute><FormSelect2 /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.formWizard,
    element: <LazyRoute><FormWizard /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.dataTable,
    element: <LazyRoute><DataTables /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.tableBasic,
    element: <LazyRoute><TablesBasic /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.iconicIcon,
    element: <LazyRoute><IonicIcons /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.placeholder,
    element: <LazyRoute><Placeholder /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.sweetalert,
    element: <LazyRoute><Alert /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.alert,
    element: <LazyRoute><AlertUi /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.tooltip,
    element: <LazyRoute><Tooltips /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.ribbon,
    element: <LazyRoute><Ribbon /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.studentGrid,
    element: <LazyRoute><StudentGrid /></LazyRoute>,
  },
  {
    path: routes.studentList,
    element: <LazyRoute><StudentList /></LazyRoute>,
  },
  {
    path: routes.studentFoodMenu,
    element: <LazyRoute><FoodMenuList /></LazyRoute>,
  },
  {
    path: routes.studentMonthlyReport,
    element: <LazyRoute><Monthlyreport /></LazyRoute>,
  },
  {
    path: routes.addStudent,
    element: <LazyRoute><AddStudent /></LazyRoute>,
  },
  {
    path: `${routes.editStudent}/:id`,
    element: <LazyRoute><AddStudent /></LazyRoute>,
  },
  {
    path: routes.studentLibrary,
    element: <LazyRoute><StudentLibrary /></LazyRoute>,
  },
  {
    path: routes.studentDetail,
    element: <LazyRoute><StudentDetails /></LazyRoute>,
  },
  {
    path: routes.studentFees,
    element: <LazyRoute><StudentFees /></LazyRoute>,
  },
  {
    path: routes.studentLeaves,
    element: <LazyRoute><StudentLeaves /></LazyRoute>,
  },
  {
    path: routes.studentResult,
    element: <LazyRoute><StudentResult /></LazyRoute>,
  },
  {
    path: routes.studentTimeTable,
    element: <LazyRoute><StudentTimeTable /></LazyRoute>,
  },
  {
    path: routes.studentRoutine,
    element: <LazyRoute><StudentRoutineView /></LazyRoute>,
  },
  {
    path: routes.studentPromotionXii,
    element: <LazyRoute><StudentComponentXii /></LazyRoute>,
  },
  {
    path: routes.StudentPromotionIX,
    element: <LazyRoute><StudentPromotionIX /></LazyRoute>,
  },
  {
    path: routes.AcademicReason,
    element: <LazyRoute><AcademicReason /></LazyRoute>,
  },
  {
    path: routes.classSyllabus,
    element: <LazyRoute><ClassSyllabus /></LazyRoute>,
  },
  {
    path: routes.classSubject,
    element: <LazyRoute><ClassSubject /></LazyRoute>,
  },
  {
    path: routes.classSection,
    element: <LazyRoute><ClassSection /></LazyRoute>,
  },
  {
    path: routes.classRoom,
    element: <LazyRoute><ClassRoom /></LazyRoute>,
  },
  {
    path: routes.ClassTimetableView,
    element: <LazyRoute><ClassTimetableView /></LazyRoute>,
  },
  {
    path: routes.ClassTimetableViewTeacher,
    element: <LazyRoute><ClassTimetableViewTeacher /></LazyRoute>,
  },
  {
    path: routes.MarksForm,
    element: <LazyRoute><MarksForm /></LazyRoute>,
  },
  {
    path: routes.TeacherMarksForm,
    element: <LazyRoute><TeacherMarksForm /></LazyRoute>,
  },
  {
    path: routes.MarksheetViewer,
    element: <LazyRoute><MarksheetViewer /></LazyRoute>,
  },
  {
    path: routes.MarksheetViewerix,
    element: <LazyRoute><MarksheetViewerix /></LazyRoute>,
  },
  {
    path: routes.Marksheeteacher,
    element: <LazyRoute><Marksheeteacher /></LazyRoute>,
  },
  {
    path: routes.MarksheetViewerxi,
    element: <LazyRoute><MarksheetViewerxi /></LazyRoute>,
  },
  {
    path: routes.academicProgress,
    element: <LazyRoute><AcademicProgress /></LazyRoute>,
  },
  {
    path: routes.AssignCard,
    element: <LazyRoute><AssignCard /></LazyRoute>,
  },
  {
    path: routes.CheckCardAssign,
    element: <LazyRoute><CheckCardAssign /></LazyRoute>,
  },
  {
    path: routes.studentAttendanceView,
    element: <LazyRoute><StudentAttendanceView /></LazyRoute>,
  },
  {
    path: routes.PublishResults,
    element: <LazyRoute><PublishResults /></LazyRoute>,
  },
  {
    path: routes.PaymentSuccess,
    element: <LazyRoute><PaymentSuccess /></LazyRoute>,
  },
  {
    path: routes.EditMarksheet,
    element: <LazyRoute><EditMarksheet /></LazyRoute>,
  },
  {
    path: routes.CumulativeMarksheet,
    element: <LazyRoute><CumulativeMarksheet /></LazyRoute>,
  },
  {
    path: routes.EpfCalculator,
    element: <LazyRoute><EpfCalculatorPage /></LazyRoute>,
  },
  {
    path: routes.CumulativeMarksheetX,
    element: <LazyRoute><CumulativeMarksheetX /></LazyRoute>,
  },
  {
    path: routes.CumulativeMarksheetXI,
    element: <LazyRoute><CumulativeMarksheetXI /></LazyRoute>,
  },
  {
    path: routes.CumulativeMarksheetstu,
    element: <LazyRoute><CumulativeMarksheetstu /></LazyRoute>,
  },
  {
    path: routes.CumulativeMarksheetstux,
    element: <LazyRoute><CumulativeMarksheetstux /></LazyRoute>,
  },
  {
    path: routes.CumulativeMarksheetstuxi,
    element: <LazyRoute><CumulativeMarksheetstuxi /></LazyRoute>,
  },
  {
    path: routes.StudentPromotion,
    element: <LazyRoute><StudentPromotion /></LazyRoute>,
  },
  {
    path: routes.PaidFees,
    element: <LazyRoute><PaidFees /></LazyRoute>,
  },
  {
    path: routes.DueFees,
    element: <LazyRoute><DueFees /></LazyRoute>,
  },
  {
    path: routes.BulkMarksUpload,
    element: <LazyRoute><BulkMarksUpload /></LazyRoute>,
  },
  {
    path: routes.BulkCumulativeDownload,
    element: <LazyRoute><BulkCumulativeDownload /></LazyRoute>,
  },
  {
    path: routes.BulkCumulativeDownloadx,
    element: <LazyRoute><BulkCumulativeDownloadx /></LazyRoute>,
  },
  {
    path: routes.BulkCumulativeDownloadxi,
    element: <LazyRoute><BulkCumulativeDownloadxi /></LazyRoute>,
  },
  {
    path: routes.MarksheetIX_X,
    element: <LazyRoute><MarksheetIX_X /></LazyRoute>,
  },
  {
    path: routes.ViewMarksheet,
    element: <LazyRoute><ViewMarksheet /></LazyRoute>,
  },
  {
    path: routes.Monthlydata,
    element: <LazyRoute><Monthlydata /></LazyRoute>,
  },
  {
    path: routes.ViewMarksheetXI,
    element: <LazyRoute><ViewMarksheetXI /></LazyRoute>,
  },
  {
    path: routes.ViewMarksheetstu,
    element: <LazyRoute><ViewMarksheetstu /></LazyRoute>,
  },
  {
    path: routes.ViewMarksheetstux,
    element: <LazyRoute><ViewMarksheetstux /></LazyRoute>,
  },
  {
    path: routes.ViewMarksheetstuxi,
    element: <LazyRoute><ViewMarksheetstuxi /></LazyRoute>,
  },
  {
    path: routes.CompletedExam,
    element: <LazyRoute><CompletedExam /></LazyRoute>,
  },
  {
    path: routes.UpcomingExam,
    element: <LazyRoute><UpcomingExam /></LazyRoute>,
  },
  {
    path: routes.OnlineExamAutoTermsCondition,
    element: <LazyRoute><OnlineExamAutoTermsCondition /></LazyRoute>,
  },
  {
    path: routes.OnlineExamManualTermsCondition,
    element: <LazyRoute><OnlineExamManualTermsCondition /></LazyRoute>,
  },
  {
    path: routes.StudentExamManual,
    element: <LazyRoute><StudentExamManual /></LazyRoute>,
  },
  {
    path: routes.StudentExamAuto,
    element: <LazyRoute><StudentExamAuto /></LazyRoute>,
  },
  {
    path: routes.ViewExam,
    element: <LazyRoute><ViewExam /></LazyRoute>,
  },
  {
    path: routes.ExamReport,
    element: <LazyRoute><ExamReport /></LazyRoute>,
  },
  {
    path: routes.ViewMarksheetX,
    element: <LazyRoute><ViewMarksheetX /></LazyRoute>,
  },
  {
    path: routes.MarksheetXI_XII,
    element: <LazyRoute><MarksheetXI_XII /></LazyRoute>,
  },
  {
    path: routes.AddFees,
    element: <LazyRoute><AddFees /></LazyRoute>,
  },
  {
    path: routes.FeesPayment,
    element: <LazyRoute><FeesPayment /></LazyRoute>,
  },
  {
    path: routes.OfflineFeesPayment,
    element: <LazyRoute><OfflineFeesPayment /></LazyRoute>,
  },
  {
    path: routes.StudentBulkUpload,
    element: <LazyRoute><StudentBulkUpload /></LazyRoute>,
  },
  {
    path: routes.TeacherBulkUpload,
    element: <LazyRoute><TeacherBulkUpload /></LazyRoute>,
  },
  {
    path: routes.MarksheetV,
    element: <LazyRoute><MarksheetV /></LazyRoute>,
  },
  {
    path: routes.PayFees,
    element: <LazyRoute><PayFees /></LazyRoute>,
  },
  {
    path: routes.classRoutine,
    element: <LazyRoute><ClassRoutine /></LazyRoute>,
  },
  {
    path: routes.routinexi,
    element: <LazyRoute><Routinexi /></LazyRoute>,
  },
  {
    path: routes.sheduleClasses,
    element: <LazyRoute><ScheduleClasses /></LazyRoute>,
  },
  {
    path: routes.exam,
    element: <LazyRoute><Exam /></LazyRoute>,
  },
  {
    path: routes.ExamQuestion,
    element: <LazyRoute><ExamQuestion /></LazyRoute>,
  },
  {
    path: routes.examSchedule,
    element: <LazyRoute><ExamSchedule /></LazyRoute>,
  },
  {
    path: routes.grade,
    element: <LazyRoute><Grade /></LazyRoute>,
  },
  {
    path: routes.staff,
    element: <LazyRoute><Staff /></LazyRoute>,
  },
  {
    path: routes.departments,
    element: <LazyRoute><Departments /></LazyRoute>,
  },
  {
    path: routes.classes,
    element: <LazyRoute><Classes /></LazyRoute>,
  },
  {
    path: routes.classHomeWork,
    element: <LazyRoute><ClassHomeWork /></LazyRoute>,
  },
  {
    path: routes.examAttendance,
    element: <LazyRoute><ExamAttendance /></LazyRoute>,
  },
  {
    path: routes.attendanceSchool,
    element: <LazyRoute><AttendanceSchool /></LazyRoute>,
  },
  {
    path: routes.attendanceAnalytics,
    element: <LazyRoute><AttendanceAnalytics /></LazyRoute>,
  },
  {
    path: routes.midDayMealReview,
    element: <LazyRoute><MidDayMealReview /></LazyRoute>,
  },
  {
    path: routes.teacherGrid,
    element: <LazyRoute><TeacherGrid /></LazyRoute>,
  },
  {
    path: routes.teacherList,
    element: <LazyRoute><TeacherList /></LazyRoute>,
  },
  {
    path: routes.addTeacher,
    element: <LazyRoute><TeacherForm /></LazyRoute>,
  },
  {
    path: `${routes.editTeacher}/:id`,
    element: <LazyRoute><EditTeacher /></LazyRoute>,
  },
  {
    path: routes.teacherDetails,
    element: <LazyRoute><TeacherDetails /></LazyRoute>,
  },
  {
    path: routes.teachersRoutine,
    element: <LazyRoute><TeachersRoutine /></LazyRoute>,
  },
  {
    path: routes.teacherSalary,
    element: <LazyRoute><TeacherSalary /></LazyRoute>,
  },
  {
    path: routes.teacherLeaves,
    element: <LazyRoute><TeacherLeave /></LazyRoute>,
  },
  {
    path: routes.teacherLibrary,
    element: <LazyRoute><TeacherLibrary /></LazyRoute>,
  },
  {
    path: routes.parentGrid,
    element: <LazyRoute><ParentGrid /></LazyRoute>,
  },
  {
    path: routes.parentList,
    element: <LazyRoute><ParentList /></LazyRoute>,
  },
  {
    path: routes.classTimetable,
    element: <LazyRoute><ClassTimetable /></LazyRoute>,
  },
  {
    path: routes.payroll,
    element: <LazyRoute><Payroll /></LazyRoute>,
  },
  {
    path: routes.designation,
    element: <LazyRoute><Designation /></LazyRoute>,
  },
  {
    path: routes.listLeaves,
    element: <LazyRoute><ListLeaves /></LazyRoute>,
  },
  {
    path: routes.staffDetails,
    element: <LazyRoute><StaffDetails /></LazyRoute>,
  },
  {
    path: routes.staffPayroll,
    element: <LazyRoute><StaffPayRoll /></LazyRoute>,
  },
  {
    path: routes.staffLeave,
    element: <LazyRoute><StaffLeave /></LazyRoute>,
  },
  {
    path: routes.layoutDefault,
    element: <LazyRoute><AdminDashboard /></LazyRoute>,
  },
  {
    path: routes.layoutMini,
    element: <LazyRoute><AdminDashboard /></LazyRoute>,
  },
  {
    path: routes.layoutRtl,
    element: <LazyRoute><AdminDashboard /></LazyRoute>,
  },
  {
    path: routes.layoutBox,
    element: <LazyRoute><AdminDashboard /></LazyRoute>,
  },
  {
    path: routes.layoutDark,
    element: <LazyRoute><AdminDashboard /></LazyRoute>,
  },
  {
    path: routes.guardiansGrid,
    element: <LazyRoute><GuardianGrid /></LazyRoute>,
  },
  {
    path: routes.guardiansList,
    element: <LazyRoute><GuardianList /></LazyRoute>,
  },
  {
    path: routes.feesGroup,
    element: <LazyRoute><FeesGroup /></LazyRoute>,
  },
  {
    path: routes.feesType,
    element: <LazyRoute><FeesTypes /></LazyRoute>,
  },
  {
    path: routes.feesMaster,
    element: <LazyRoute><FeesMaster /></LazyRoute>,
  },
  {
    path: routes.feesAssign,
    element: <LazyRoute><FeesAssign /></LazyRoute>,
  },
  {
    path: routes.collectFees,
    element: <LazyRoute><CollectFees /></LazyRoute>,
  },
  {
    path: routes.libraryMembers,
    element: <LazyRoute><LibraryMember /></LazyRoute>,
  },
  {
    path: routes.libraryBooks,
    element: <LazyRoute><Books /></LazyRoute>,
  },
  {
    path: routes.libraryIssueBook,
    element: <LazyRoute><IssueBook /></LazyRoute>,
  },
  {
    path: routes.libraryReturn,
    element: <LazyRoute><ReturnBook /></LazyRoute>,
  },
  {
    path: routes.sportsList,
    element: <LazyRoute><SportsList /></LazyRoute>,
  },
  {
    path: routes.playerList,
    element: <LazyRoute><PlayersList /></LazyRoute>,
  },
  {
    path: routes.hostelRoom,
    element: <LazyRoute><HostelRooms /></LazyRoute>,
  },
  {
    path: routes.hostelType,
    element: <LazyRoute><HostelType /></LazyRoute>,
  },
  {
    path: routes.hostelList,
    element: <LazyRoute><HostelList /></LazyRoute>,
  },
  {
    path: routes.monthwiseForm,
    element: <LazyRoute><Monthwise /></LazyRoute>,
  },
  {
    path: routes.StudyMaterial,
    element: <LazyRoute><StudyMaterial /></LazyRoute>,
  },
  {
    path: routes.AddmissionApp,
    element: <LazyRoute><Addmissionapp /></LazyRoute>,
  },
  {
    path: routes.ApplicationReceived,
    element: <LazyRoute><ApplicationReceived /></LazyRoute>,
  },
  {
    path: routes.StudyMaterialView,
    element: <LazyRoute><StudyMaterialView /></LazyRoute>,
  },
  {
    path: routes.StudyMaterialFeedbacks,
    element: <LazyRoute><StudyMaterialFeedbacks /></LazyRoute>,
  },
  {
    path: routes.transportRoutes,
    element: <LazyRoute><TransportRoutes /></LazyRoute>,
  },
  {
    path: routes.LiveClass,
    element: <LazyRoute><LiveClass /></LazyRoute>,
  },
  {
    path: routes.transportAssignVehicle,
    element: <LazyRoute><TransportAssignVehicle /></LazyRoute>,
  },
  {
    path: routes.transportPickupPoints,
    element: <LazyRoute><TransportPickupPoints /></LazyRoute>,
  },
  {
    path: routes.transportVehicleDrivers,
    element: <LazyRoute><TransportVehicleDrivers /></LazyRoute>,
  },
  {
    path: routes.transportVehicle,
    element: <LazyRoute><TransportVehicle /></LazyRoute>,
  },
  {
    path: routes.approveRequest,
    element: <LazyRoute><ApproveRequest /></LazyRoute>,
  },
  {
    path: routes.studentAttendance,
    element: <LazyRoute><StudentAttendance /></LazyRoute>,
  },
  {
    path: routes.teacherAttendance,
    element: <LazyRoute><TeacherAttendance /></LazyRoute>,
  },
  {
    path: routes.teacherQrAttendanceAdmin,
    element: <LazyRoute><TeacherQrAttendanceAdmin /></LazyRoute>,
  },
  {
    path: routes.teacherQrAttendanceScan,
    element: <LazyRoute><TeacherQrAttendanceScan /></LazyRoute>,
  },
  {
    path: routes.staffAttendance,
    element: <LazyRoute><StaffAttendance /></LazyRoute>,
  },
  {
    path: routes.staffsAttendance,
    element: <LazyRoute><StaffsAttendance /></LazyRoute>,
  },
  {
    path: routes.addStaff,
    element: <LazyRoute><AddStaff /></LazyRoute>,
  },
  {
    path: routes.editStaff,
    element: <LazyRoute><EditStaff /></LazyRoute>,
  },
  {
    path: routes.accountsIncome,
    element: <LazyRoute><AccountsIncome /></LazyRoute>,
  },
  {
    path: routes.accountsInvoices,
    element: <LazyRoute><AccountsInvoices /></LazyRoute>,
  },
  {
    path: routes.accountsTransactions,
    element: <LazyRoute><AccountsTransactions /></LazyRoute>,
  },
  {
    path: routes.addInvoice,
    element: <LazyRoute><AddInvoice /></LazyRoute>,
  },
  {
    path: routes.editInvoice,
    element: <LazyRoute><EditInvoice /></LazyRoute>,
  },
  {
    path: routes.expense,
    element: <LazyRoute><Expense /></LazyRoute>,
  },
  {
    path: routes.financialReview,
    element: <LazyRoute><FinancialReview /></LazyRoute>,
  },
  {
    path: routes.expenseCategory,
    element: <LazyRoute><ExpensesCategory /></LazyRoute>,
  },
  {
    path: routes.incomeCategory,
    element: <LazyRoute><IncomeCategory /></LazyRoute>,
  },
  {
    path: routes.invoice,
    element: <LazyRoute><Invoice /></LazyRoute>,
  },
  {
    path: routes.events,
    element: <LazyRoute><Events /></LazyRoute>,
  },
  {
    path: routes.Study,
    element: <LazyRoute><Study /></LazyRoute>,
  },
  {
    path: routes.noticeBoard,
    element: <LazyRoute><NoticeBoard /></LazyRoute>,
  },
  {
    path: routes.profilesettings,
    element: <LazyRoute><Profilesettings /></LazyRoute>,
  },
  {
    path: routes.securitysettings,
    element: <LazyRoute><Securitysettings /></LazyRoute>,
  },
  {
    path: routes.notificationssettings,
    element: <LazyRoute><Notificationssettings /></LazyRoute>,
  },
  {
    path: routes.companySettings,
    element: <LazyRoute><CompanySettings /></LazyRoute>,
  },
  {
    path: routes.localization,
    element: <LazyRoute><Localization /></LazyRoute>,
  },
  {
    path: routes.prefixes,
    element: <LazyRoute><Prefixes /></LazyRoute>,
  },
  {
    path: routes.socialAuthentication,
    element: <LazyRoute><Socialauthentication /></LazyRoute>,
  },
  {
    path: routes.language,
    element: <LazyRoute><Languagesettings /></LazyRoute>,
  },
  {
    path: routes.invoiceSettings,
    element: <LazyRoute><InvoiceSettings /></LazyRoute>,
  },
  {
    path: routes.emailSettings,
    element: <LazyRoute><EmailSettings /></LazyRoute>,
  },
  {
    path: routes.emailTemplates,
    element: <LazyRoute><Emailtemplates /></LazyRoute>,
  },
  {
    path: routes.smsSettings,
    element: <LazyRoute><SmsSettings /></LazyRoute>,
  },
  {
    path: routes.optSettings,
    element: <LazyRoute><OtpSettings /></LazyRoute>,
  },
  {
    path: routes.gdprCookies,
    element: <LazyRoute><GdprCookies /></LazyRoute>,
  },
  {
    path: routes.paymentGateways,
    element: <LazyRoute><PaymentGateways /></LazyRoute>,
  },
  {
    path: routes.taxRates,
    element: <LazyRoute><TaxRates /></LazyRoute>,
  },
  {
    path: routes.schoolSettings,
    element: <LazyRoute><SchoolSettings /></LazyRoute>,
  },
  {
    path: routes.religion,
    element: <LazyRoute><Religion /></LazyRoute>,
  },
  {
    path: routes.storage,
    element: <LazyRoute><Storage /></LazyRoute>,
  },
  {
    path: routes.rolesPermissions,
    element: <LazyRoute><RolesPermissions /></LazyRoute>,
  },
  {
    path: routes.permissions,
    element: <LazyRoute><Permission /></LazyRoute>,
  },
  {
    path: routes.manageusers,
    element: <LazyRoute><Manageusers /></LazyRoute>,
  },
  {
    path: routes.allBlogs,
    element: <LazyRoute><AllBlogs /></LazyRoute>,
  },
  {
    path: routes.blogCategories,
    element: <LazyRoute><BlogCategories /></LazyRoute>,
  },
  {
    path: routes.blogComments,
    element: <LazyRoute><BlogComments /></LazyRoute>,
  },
  {
    path: routes.blogTags,
    element: <LazyRoute><BlogTags /></LazyRoute>,
  },
  {
    path: routes.tickets,
    element: <LazyRoute><Tickets /></LazyRoute>,
  },
  {
    path: routes.ticketGrid,
    element: <LazyRoute><TicketGrid /></LazyRoute>,
  },
  {
    path: routes.ticketDetails,
    element: <LazyRoute><TicketDetails /></LazyRoute>,
  },
  {
    path: routes.supportChat,
    element: <LazyRoute><SupportChat /></LazyRoute>,
  },
  {
    path: routes.feesReport,
    element: <LazyRoute><FeesReport /></LazyRoute>,
  },
  {
    path: routes.leaveReport,
    element: <LazyRoute><LeaveReport /></LazyRoute>,
  },
  {
    path: routes.gradeReport,
    element: <LazyRoute><GradeReport /></LazyRoute>,
  },
  {
    path: routes.studentReport,
    element: <LazyRoute><StudentReport /></LazyRoute>,
  },
  {
    path: routes.classReport,
    element: <LazyRoute><ClassReport /></LazyRoute>,
  },
  {
    path: routes.attendanceReport,
    element: <LazyRoute><AttendanceReport /></LazyRoute>,
  },
  {
    path: routes.studentAttendanceType,
    element: <LazyRoute><StudentAttendanceType /></LazyRoute>,
  },
  {
    path: routes.dailyAttendance,
    element: <LazyRoute><DailyAttendance /></LazyRoute>,
  },
  {
    path: routes.studentDayWise,
    element: <LazyRoute><StudentDayWise /></LazyRoute>,
  },
  {
    path: routes.teacherDayWise,
    element: <LazyRoute><TeacherDayWise /></LazyRoute>,
  },
  {
    path: routes.staffDayWise,
    element: <LazyRoute><StaffDayWise /></LazyRoute>,
  },
  {
    path: routes.teacherReport,
    element: <LazyRoute><TeacherReport /></LazyRoute>,
  },
  {
    path: routes.staffReport,
    element: <LazyRoute><StaffReport /></LazyRoute>,
  },
  {
    path: routes.contactMessages,
    element: <LazyRoute><ContactMessages /></LazyRoute>,
  },
  {
    path: routes.profile,
    element: <LazyRoute><Profile /></LazyRoute>,
  },
  {
    path: routes.activity,
    element: <LazyRoute><NotificationActivities /></LazyRoute>,
  },
  {
    path: routes.sendSms,
    element: <LazyRoute><SendSms /></LazyRoute>,
  },
];

export const authRoutes = [
  {
    path: routes.comingSoon,
    element: <LazyRoute><ComingSoon /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.login,
    element: <LazyRoute><Login /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.login2,
    element: <LazyRoute><Login2 /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.login3,
    element: <LazyRoute><Login3 /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.login4,
    element: <LazyRoute><Login4 /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.register,
    element: <LazyRoute><Register /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.twoStepVerification,
    element: <LazyRoute><TwoStepVerification /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.twoStepVerification2,
    element: <LazyRoute><TwoStepVerification2 /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.twoStepVerification3,
    element: <LazyRoute><TwoStepVerification3 /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.emailVerification,
    element: <LazyRoute><EmailVerification /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.emailVerification2,
    element: <LazyRoute><EmailVerification2 /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.emailVerification3,
    element: <LazyRoute><EmailVerification3 /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.register2,
    element: <LazyRoute><Register2 /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.register3,
    element: <LazyRoute><Register3 /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.resetPassword,
    element: <LazyRoute><ResetPassword /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.resetPassword2,
    element: <LazyRoute><ResetPassword2 /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.resetPassword3,
    element: <LazyRoute><ResetPassword3 /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.forgotPassword,
    element: <LazyRoute><ForgotPassword /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.forgotPassword2,
    element: <LazyRoute><ForgotPassword2 /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.forgotPassword3,
    element: <LazyRoute><ForgotPassword3 /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.error404,
    element: <LazyRoute><Error404 /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.error500,
    element: <LazyRoute><Error500 /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.underMaintenance,
    element: <LazyRoute><UnderMaintenance /></LazyRoute>,
    route: Route,
  },
  {
    path: routes.lockScreen,
    element: <LazyRoute><LockScreen /></LazyRoute>,
  },
  {
    path: routes.resetPasswordSuccess,
    element: <LazyRoute><ResetPasswordSuccess /></LazyRoute>,
  },
  {
    path: routes.resetPasswordSuccess2,
    element: <LazyRoute><ResetPasswordSuccess2 /></LazyRoute>,
  },
  {
    path: routes.resetPasswordSuccess3,
    element: <LazyRoute><ResetPasswordSuccess3 /></LazyRoute>,
  },
];

